import React from 'react'

export default function PulseLoading() {
  return (
    <div className='h-4 animate-pulse rounded-full bg-pop-gray-5' data-testid='pulse-loading' />
  )
}
